import constants from "../utils/Constants";
import { getData, postData, putData } from "./rest-api-helper";


export async function getPoListServ({ limit, pageNumber, searchWord, projIdStrg, status, type, userType, userId, sort }) {
    if (type === "com") {
        const details = {
            urlPath: "/po/byProj",
            queryParams: {
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(projIdStrg && { projIdStrg }),
                ...(status && { status }),
                ...(sort && { sort }),
            }
        }
        const res = await getData(details);
        return res.data;
    } else {
        if (userType === constants.admin || userType === constants.accounts) {
            const details = {
                urlPath: "/po/byProj",
                queryParams: {
                    ...(searchWord && { searchWord }),
                    ...(limit && { limit }),
                    ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                    ...(status && { status }),
                    ...(sort && { sort }),
                }
            }
            const res = await getData(details);
            return res.data;
        }
        if (userType === constants.sourcing) {
            const details = {
                urlPath: "/source/po",
                queryParams: {
                    sourceUserId: userId,
                    ...(searchWord && { searchWord }),
                    ...(limit && { limit }),
                    ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                    ...(status && { status }),
                    ...(sort && { sort }),
                }
            }
            const res = await getData(details);
            return res.data;
        }
    }

}

export async function getSinglePo(poIdStrg) {
    const details = {
        urlPath: `/po/single/${poIdStrg}`
    }
    const res = await getData(details);
    return res.data;
}

export async function getPoByStoreServ({ comId, limit, pageNumber, searchWord, status, sort }) {
    const details = {
        urlPath: "/store/po",
        queryParams: {
            ...(searchWord && { searchWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(status && { status }),
            ...(comId && { comId }),
            ...(sort && { sort }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getSinglePoStoreServ(poIdStrg) {
    const details = {
        urlPath: `/store/po/single/${poIdStrg}`
    }
    const res = await getData(details);
    return res.data;
}

export async function getSingleDoServ(doIdStrg) {
    const details = {
        urlPath: `/po/doSingle/${doIdStrg}`
    }
    const res = await getData(details);
    return res.data;
}

export async function createDoServ(data) {
    const details = {
        urlPath: "/po/createDo",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

// export async function getSingleDoEditServ(doIdStrg) { need to fix api code for this
//     const details = {
//         urlPath: `/po/doSingleEdit/${doIdStrg}`
//     } 
//     const res = await getData(details);
//     return res.data;
// }

export async function editDoInvServ(data) {
    const details = {
        urlPath: "/po/editDoInv",
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getPoTrackingServ({ comId, limit, pageNumber, searchWord, searchType, sort, userType, projIdStrg, prodStatus, userId }) {
    if (userType === constants.lineManager || userType === constants.focalPoint) {
        const details = {
            urlPath: "/po/tracking",
            queryParams: {
                ...(comId && { comId }),
                ...(projIdStrg ? { projIdStrg } : { projIdStrg: "aaaaaaaaaa" }),
                ...(searchWord && { searchWord }),
                ...(searchType && { searchType }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(sort && { sort }),
                ...(prodStatus && { prodStatus })
            }
        }
        const res = await getData(details);
        return res.data;
    } else if (userType === constants.approver) {
        const details = {
            urlPath: "/po/tracking",
            queryParams: {
                ...(comId && { comId }),
                ...(userId && { userId }),
                ...(searchWord && { searchWord }),
                ...(searchType && { searchType }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(sort && { sort }),
                ...(prodStatus && { prodStatus })
            }
        }
        const res = await getData(details);
        return res.data;
    } else {
        const details = {
            urlPath: "/po/tracking",
            queryParams: {
                ...(comId && { comId }),
                ...(searchWord && { searchWord }),
                ...(searchType && { searchType }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(sort && { sort }),
                ...(prodStatus && { prodStatus })
            }
        }
        const res = await getData(details);
        return res.data;
    }

}

export async function getSinglePoProdServ(poProdId) {
    const details = {
        urlPath: `/po/getSinglePoProd/${poProdId}`
    }
    const res = await getData(details);
    return res.data;
}

export async function editPoProdTrackServ(data) {
    const details = {
        urlPath: "/po/editPoProdTrack",
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function editPoProdClientRemarkServ(data, isTemp) {
    if (isTemp === 0) {
        const details = {
            urlPath: "/po/editPoProdClientRemark",
            body: {
                ...data
            }
        }
        const res = await putData(details);
        return res;
    } else {
        const details = {
            urlPath: "/pot/editPoProdClientRemark",
            body: {
                ...data
            }
        }
        const res = await putData(details);
        return res;
    }
}

export async function getSinglePotServ(poId) {
    const details = {
        urlPath: `/pot/single/${poId}`
    }
    const res = await getData(details);
    return res.data;
}

export async function editPotServ(data, poId) {
    const details = {
        urlPath: `/pot/edit/${poId}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function editPotDoInvServ(data) {
    const details = {
        urlPath: `/pot/editDoInv`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getSinglePotProdServ(poProdId) {
    const details = {
        urlPath: `/pot/getSinglePoProd/${poProdId}`
    }
    const res = await getData(details);
    return res.data;
}